import { render, staticRenderFns } from "./return-confirmation.vue?vue&type=template&id=aa26a5a0&"
import script from "./return-confirmation.vue?vue&type=script&lang=js&"
export * from "./return-confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports